<app-base-page-template>
  <app-base-page-content-template>
    <app-employees-grid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-employees-grid>
  </app-base-page-content-template>
</app-base-page-template>
